<template>
  <b-overlay
    id="overlay-background"
    :show="modulesLoader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row
      v-if="caseProcessesCompleted"
    >
      <b-col sm="12">
        <b-card
          class="processcompletedmessage"
        >
          <b-alert
            variant="primary"
            class="processcompletedmessagealert"
            show
          >
            <div class="alert-body">
              <span>{{ $t('DEBTIA_PROCESS_COMPLETED') }}</span>
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      v-else
    >
      <b-col sm="4">
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            {{ $t('DEBTIA_CURRENT_MODULE') }}
          </b-list-group-item>
          <b-list-group-item
            href="#"
          >
            {{ active_module.module_title ? active_module.module_title : 'N/A' }}
            {{ active_module.module_id === 1 ? `(${active_module.module_settings.awaitedDays} ${$t('DEBTIA_DAYS_LEFT')})` : '' }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col sm="4">
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            {{ $t('DEBTIA_NEXT_MODULE') }}
          </b-list-group-item>
          <b-list-group-item
            href="#"
          >
            {{ next_module.module_title ? next_module.module_title : 'N/A' }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col sm="4">
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            {{ $t('DEBTIA_PROCESSES') }}
          </b-list-group-item>
          <div
            v-for="(data,index) in processCases"
            :key="index"
          >
            <b-list-group-item :href="`/process/view/${data.process_id}`">
              {{ data.title }}
            </b-list-group-item>
          </div>
        </b-list-group>
      </b-col>
      <b-col
        v-if="caseUserActions"
        sm="4"
        class="user-action-buttons"
      >
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            User Action Buttons
          </b-list-group-item>
          <b-list-group-item
            v-if="caseUserActions.await"
          >
            <strong>{{ $t('DEBTIA_AWAIT_DAYS_LEFT').replace('X', caseUserActions.await_days) }}</strong>
          </b-list-group-item>
          <b-list-group-item>
            <strong>Description: </strong> {{ caseUserActions.description }}
          </b-list-group-item>
          <b-list-group-item
            v-if="caseStateData && caseStateData.state === 'pause'"
          >
            <b-alert
              variant="warning"
              show
            >
              <div class="alert-body">
                <span>This case is put in pause by {{ caseStateData.employee_name }} until {{ getFormatedDate(caseStateData.pause_date) }} because of {{ caseStateData.description }}.</span>
              </div>
            </b-alert>
          </b-list-group-item>
          <b-list-group-item>
            <template v-for="(data, index) in caseUserActions.buttons">
              <b-button
                v-if="!data.await"
                :key="index"
                :variant="getBtnVariant(data.button_color)"
                class="user-action-button"
                @click="userActionBtnClicked(data.id, caseUserActions.process_id, null, 1)"
              >
                {{ data.button_title }}
              </b-button>
            </template>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <b-row>
      <template
        v-if="secondaryProcessUserActions.length > 0"
      >
        <b-col
          v-for="(userAction, index) in secondaryProcessUserActions"
          :key="index"
          sm="4"
          class="user-action-buttons"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              Secondary Process: User Action Buttons
            </b-list-group-item>
            <b-list-group-item
              v-if="userAction.await"
            >
              <strong>{{ $t('DEBTIA_AWAIT_DAYS_LEFT').replace('X', userAction.await_days) }}</strong>
            </b-list-group-item>
            <b-list-group-item>
              <strong>Description: </strong> {{ userAction.description }}
            </b-list-group-item>
            <b-list-group-item
              v-if="caseStateData && caseStateData.state === 'pause'"
            >
              <b-alert
                variant="warning"
                show
              >
                <div class="alert-body">
                  <span>This case is put in pause by {{ caseStateData.employee_name }} until {{ getFormatedDate(caseStateData.pause_date) }} because of {{ caseStateData.description }}.</span>
                </div>
              </b-alert>
            </b-list-group-item>
            <b-list-group-item>
              <template v-for="(data, index) in userAction.buttons">
                <b-button
                  v-if="!data.await"
                  :key="index"
                  :variant="getBtnVariant(data.button_color)"
                  class="user-action-button"
                  @click="userActionBtnClicked(data.id, userAction.process_id, userAction, 2)"
                >
                  {{ data.button_title }}
                </b-button>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </template>
    </b-row>
    <b-modal
      id="user-action-modal"
      ref="user-action-modal"
      centered
      title="Button Action"
      ok-title="Submit"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      @show="resetModal"
      @hidden="resetModal"
      @ok="validationButtonForm"
    >
      <b-overlay
        id="overlay-background"
        :show="btnloader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <validation-observer ref="buttonRules">
          <b-form>
            <b-alert
              v-if="buttonError"
              variant="warning"
              show
            >
              <div class="alert-body">
                {{ buttonError }}
              </div>
            </b-alert>
            <b-row>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="description"
                      :placeholder="$t('DEBTIA_DESCRIPTION')"
                      rows="8"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_FILE')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    v-slot="{ validate, errors }"
                    name="File"
                    rules="required"
                  >
                    <b-form-file
                      id="file-default"
                      ref="button-file"
                      @change="validate($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </b-modal>
    <user-action-reason-modal
      ref="reasonPopup"
      :reason="reasonbtn"
      :process-id="processId"
      :user-action-button-clicked="userActionButtonClicked"
      :btn-type="btnType"
    />
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BListGroup, BListGroupItem, BOverlay, BModal, BForm, BFormGroup, BFormFile, BFormTextarea,
  BButton,
  BCard, BAlert,
} from 'bootstrap-vue'
// import store from '@/store'
import { EventBus } from '@/event-bus'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import UserActionReasonModal from './userActionReasonModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BButton,
    BCard,
    BAlert,
    BOverlay,
    BModal,
    BFormGroup,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormTextarea,
    UserActionReasonModal,
  },
  directives: {
    Ripple,
  },
  props: {
    caseStateData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modulesLoader: false,
      active_module: [],
      next_module: [],
      processCases: [],
      caseProcessesCompleted: 0,
      caseUserActions: {},
      description: '',
      buttonError: '',
      btnloader: false,
      reasonbtn: {},
      processId: 0,
      btnType: 0,
      secondaryProcessUserActions: [],
    }
  },
  created() {
    this.getModuleDetails()
    this.getSecondaryProcesses()
    EventBus.$on('refreshModules', () => {
      this.getModuleDetails()
    })
  },
  methods: {
    async getSecondaryProcesses() {
      this.secondaryProcessUserActions = []
      const caseID = this.$route.params.id
      const url = `/debt-case/secondary-process-data/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          const { process_cases } = response.data.data
          process_cases.forEach(element => {
            if (element.process_data.userActions && (element.process_data.userActions.recipient === 'partner' && element.process_data.active_module.module_id === 9)) {
              this.secondaryProcessUserActions.push(element.process_data.userActions)
            }
          })
        }
      })
    },
    validationButtonForm(evt) {
      evt.preventDefault()
      this.$refs.buttonRules.validate().then(success => {
        const caseId = this.$route.params.id
        const file = this.$refs['button-file'].files[0]
        const form = new FormData()
        form.append('process_id', this.processId)
        form.append('description', this.description)
        form.append('button_id', this.clickedBtn)
        form.append('case_id', caseId)
        form.append('file_proof', file)
        if (success) {
          this.btnloader = true
          const url = '/process/case/run-button-module'
          axios.post(url, form).then(response => {
            if (response.status === 200) {
              this.btnloader = false
              this.$refs['user-action-modal'].hide()
              this.getModuleDetails()
              EventBus.$emit('refreshStateData')
            }
          })
        }
      })
    },
    getFormatedDate(value) {
      const currentDate = new Date(value)
      // Define the date format options
      const dateFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }

      // Format the date
      const formattedDate = new Intl.DateTimeFormat('en-US', dateFormatOptions).format(currentDate)
      return formattedDate
    },
    getBtnVariant(variant) {
      const btncolor = variant.includes('#') ? 'relief-primary' : `relief-${variant.toLowerCase()}`
      return btncolor
    },
    actionBtnClicked(id, processId) {
      this.clickedBtn = id
      this.processId = processId
    },
    async getModuleDetails() {
      this.modulesLoader = true
      const caseID = this.$route.params.id
      const url = `/debt-case/process/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.active_module = response.data.data.process_data.active_module
          this.next_module = response.data.data.process_data.next_module
          this.processCases = response.data.data.process_cases
          this.caseUserActions = response.data.data.userActions
          this.caseProcessesCompleted = response.data.data.process_cases && response.data.data.process_cases.length > 0 ? response.data.data.process_cases[0].completed : false
          this.modulesLoader = false
          const processID = response.data.data.process_cases.length > 0 ? response.data.data.process_cases[0].process_id : 0
          EventBus.$emit('getFirstProcessId', processID)
        }
      })
    },
    userActionBtnClicked(id, processId, userActionObject, btnType) {
      let reasonbtn = {}
      if (userActionObject) {
        reasonbtn = userActionObject.buttons.find(item => item.id === id)
      } else {
        reasonbtn = this.caseUserActions.buttons.find(item => item.id === id)
      }
      this.reasonbtn = reasonbtn
      this.processId = processId
      this.clickedBtnId = reasonbtn.id
      this.btnType = btnType
      if (reasonbtn.reason) {
        setTimeout(() => {
          this.$refs.reasonPopup.open()
        }, 100)
      } else {
        this.userActionButtonClicked(id, processId, 0, '', btnType)
      }
    },
    userActionButtonClicked(buttonId, processId, reason, reasonDescription, type) {
      this.modulesLoader = true
      const caseId = this.$route.params.id
      const form = new FormData()
      form.append('process_id', processId)
      form.append('button_id', buttonId)
      form.append('case_id', caseId)
      form.append('reason', reason)
      form.append('reason_description', reasonDescription)
      const url = '/process/case/run-button-module'
      axios.post(url, form).then(response => {
        if (response.status === 200) {
        // this.loader = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Action performed on button.',
            },
          })

          if (type === 1) {
            this.getModuleDetails()
          }
          if (type === 2) {
            this.getSecondaryProcesses()
          }
          this.modulesLoader = false
          EventBus.$emit('refreshLogs')
        }
      }).catch(e => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Failed',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: this.$t(e.response.data.message[0]),
          },
        })
        this.modulesLoader = false
      })
    },
    resetModal() {
      this.description = ''
      this.buttonError = ''
    },
  },
}
</script>

<style lang="scss">
</style>
